import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getMediaFiles, saveMediaFiles } from "../../../services/studentService"

const initialState = {
    saveMediaFilesDetails: {
      status: "idle",
      error: null,
      message: '',
    },
    getMediaFilesDetails: {
      status: "idle",
      error: null,
      data: [],
    }
}

export const saveAudioAndVideoFiles = createAsyncThunk(
    "audioAndVideo/saveAudioAndVideoFiles",
    async (data) => {
      const response = await saveMediaFiles(data)
      console.log("response",response)
      return response
    }
)

export const getAudioAndVideoFiles = createAsyncThunk(
    "audioAndVideo/getAudioAndVideoFiles",
    async (data) => {
        const response = await getMediaFiles(data)
        return response
    }
)
  

export const audioAndVideoSlice = createSlice({
    name: "audioAndVideo",
    initialState,
    reducers: {
        resetSaveMediaFilesDetails: (state) => {
            state.saveMediaFilesDetails = initialState.saveMediaFilesDetails
        }
    },
    extraReducers: {
      [saveAudioAndVideoFiles.pending]: (state) => {
        state.saveMediaFilesDetails.status = "loading"
      },
      [saveAudioAndVideoFiles.fulfilled]: (state, action) => {
        if(action.payload.message) {
          state.saveMediaFilesDetails.status = 'succeeded'
          state.saveMediaFilesDetails.message = action.payload.message
        }else{
            state.saveMediaFilesDetails.status = "failed"
            state.saveMediaFilesDetails.error = "Some Technical Issue"
        }
      },
      [saveAudioAndVideoFiles.rejected]: (state, action) => {
        state.saveMediaFilesDetails.status = "failed"
        state.saveMediaFilesDetails.error = action.error.message
      },

      [getAudioAndVideoFiles.pending]: (state) => {
        state.getMediaFilesDetails.status = "loading"
      },
      [getAudioAndVideoFiles.fulfilled]: (state, action) => {
        if(action.payload) {
            state.getMediaFilesDetails.status = 'succeeded'
            state.getMediaFilesDetails.data = action.payload
          }else{
            state.getMediaFilesDetails.status = "failed"
            state.getMediaFilesDetails.error = "No records found"
          }
      },
      [getAudioAndVideoFiles.rejected]: (state, action) => {
        state.getMediaFilesDetails.status = "failed"
        state.getMediaFilesDetails.error = action.error.message
      }
    }
  })
  
  export const { resetSaveMediaFilesDetails } = audioAndVideoSlice.actions
  
  export default audioAndVideoSlice.reducer